export default "__VITE_ASSET__DdZVbrJT__"